import { createFileRoute, notFound } from '@tanstack/react-router';

import { lazyScreen } from '@/shared/screen/lazy-screen';

// /dev/usuarios-aplicacao (só dev): as telas reais sobre o backend em memória. Fora de DEV a rota responde
// 404 e o `-page` (harness, handlers e fixtures) não entra no bundle de produção.
export const Route = createFileRoute('/dev/usuarios-aplicacao/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound é o contrato do Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV
    ? lazyScreen(() => import('./-page'), 'SystemApplicationDevPage')
    : () => null,
});
